var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4115_3553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3384 18.3369V27.8511L16.5881 32.4489L4.83789 27.8511V18.3756",
    stroke: "#A6A6A6",
    strokeWidth: 1.38238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3381 11.0215L32.4853 16.5511L20.735 21.0438L16.5879 15.5143",
    stroke: "#A6A6A6",
    strokeWidth: 1.38238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83855 11.0215L0.691406 16.5511L12.4416 21.0438L16.5888 15.5143",
    stroke: "#A6A6A6",
    strokeWidth: 1.38238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5918 11.0588V0.690918",
    stroke: "#A6A6A6",
    strokeWidth: 1.38238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8262 3.45569L16.5909 0.690918L19.3557 3.45569",
    stroke: "#A6A6A6",
    strokeWidth: 1.38238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5679 8.29443L4.83984 11.0219L16.5901 15.4545L28.3403 11.0219L21.6123 8.29443",
    stroke: "#A6A6A6",
    strokeWidth: 1.38238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8242 6.56592V9.67628",
    stroke: "#A6A6A6",
    strokeWidth: 1.38238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.826 12.4415C14.2077 12.4415 14.5171 12.132 14.5171 11.7503C14.5171 11.3685 14.2077 11.0591 13.826 11.0591C13.4442 11.0591 13.1348 11.3685 13.1348 11.7503C13.1348 12.132 13.4442 12.4415 13.826 12.4415Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3555 6.56592V9.67628",
    stroke: "#A6A6A6",
    strokeWidth: 1.38238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3553 12.4415C19.737 12.4415 20.0464 12.132 20.0464 11.7503C20.0464 11.3685 19.737 11.0591 19.3553 11.0591C18.9735 11.0591 18.6641 11.3685 18.6641 11.7503C18.6641 12.132 18.9735 12.4415 19.3553 12.4415Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5877 13.8238C16.9694 13.8238 17.2789 13.5143 17.2789 13.1326C17.2789 12.7509 16.9694 12.4414 16.5877 12.4414C16.2059 12.4414 15.8965 12.7509 15.8965 13.1326C15.8965 13.5143 16.2059 13.8238 16.5877 13.8238Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5898 31.7574V15.5469",
    stroke: "#A6A6A6",
    strokeWidth: 1.38238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4115_3553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnbox);
export default __webpack_public_path__ + "static/media/unbox.6f7b964a1ce817df62c0e8292cbf62ff.svg";
export { ForwardRef as ReactComponent };